import { HoverText, Icon } from '@advanza/ui'
import { useNavigate } from 'react-router-dom'

interface DemandUserButtonProps {
    demandUserRequestId: number | null
}

const DemandUserButton = ({ demandUserRequestId }: DemandUserButtonProps) => {
    const navigate = useNavigate()

    if (!demandUserRequestId) {
        return null
    }

    const handleClick = () => {
        navigate(`/service/requests/request/${demandUserRequestId}`)
    }

    return (
        <HoverText
            trigger={
                <Icon
                    name="assignment_ind"
                    green
                    onClick={handleClick}
                    style={{ cursor: 'pointer', marginLeft: '2px' }}
                />
            }>
            View Latest Demand User Request
        </HoverText>
    )
}

export default DemandUserButton
